import jwt_decode from "jwt-decode";
 
export function decodeJwt(token:string):Object|unknown{
return jwt_decode(token);
}